export default __webpack_public_path__ + "static/media/logo2.aaae8f42.svg";